// Sales/POS types

import type { PosPackageStockItem } from '../../api/packages';

export enum PaymentMethod {
  CASH = 'CASH',
  CARD = 'CARD',
  TRANSFER = 'TRANSFER',
  VOUCHER = 'VOUCHER',
  CREDIT = 'CREDIT',
  MIXED = 'MIXED',
}

export enum SaleStatus {
  DRAFT = 'DRAFT',
  COMPLETED = 'COMPLETED',
  CANCELLED = 'CANCELLED',
  REFUNDED = 'REFUNDED',
}

export interface Product {
  id: string;
  sku: string;
  name: string;
  category: string;
  price: number;
  vatRate: number;
  stock: number;
  unit: string;
  barcode?: string;
}

export interface CartItem {
  product: Product;
  quantity: number;
  discount: number;
  lineTotal: number;
  /**
   * POS-csomag-sor (Q-T043): jelen van, ha ez egy SALES-csomag eladás. A csomag 1
   * billing-sorként jelenik meg (csomag-ár), de a sale-write a stockItems-ből csökkenti
   * a készletet tételenként (BE atomi — Q-T044), NEM a product.stock-ból.
   */
  packageStockItems?: PosPackageStockItem[];
  /** A csomag komponenseinek eredeti ár-összege — a Szett-megtakarítás-badge delta-forrása. */
  packageOriginalSum?: number | null;
}

export interface Customer {
  id: string;
  name: string;
  email?: string;
  phone?: string;
  taxNumber?: string;
  type: 'INDIVIDUAL' | 'COMPANY';
}

export interface Sale {
  id: string;
  saleNumber: string;
  date: string;
  customer?: Customer;
  items: CartItem[];
  subtotal: number;
  vatAmount: number;
  discount: number;
  total: number;
  paymentMethod: PaymentMethod;
  status: SaleStatus;
  cashierId: string;
  cashierName: string;
  receiptNumber?: string;
}
